import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CalendarDays, Clock } from "lucide-react";
import { api } from "../api";
import { Reveal } from "../components/Reveal";

export default function Blog() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  return (
    <main className="mx-auto max-w-7xl px-4 pb-24 pt-32 sm:px-6" data-testid="blog-page">
      <Reveal>
        <h1 className="font-display text-4xl font-extrabold tracking-tight sm:text-5xl">Blog <span className="gradient-text">DigiLib</span></h1>
        <p className="mt-4 max-w-xl text-slate-400">Nowości wydawnicze, recenzje i techniki czytania — dla ludzi, którzy kochają książki.</p>
      </Reveal>

      <div className="mt-12 grid gap-6 md:grid-cols-2">
        {posts.map((p, i) => (
          <Reveal key={p.slug} delay={i * 90}>
            <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`}
              className="group block overflow-hidden rounded-2xl glass-panel transition-[border-color,transform] duration-300 hover:-translate-y-1.5 hover:border-cyan-400/40">
              <div className={`h-44 bg-gradient-to-br ${p.gradient} relative overflow-hidden`}>
                <div className="absolute inset-0 opacity-25" style={{ background: "radial-gradient(circle at 70% 20%, rgba(255,255,255,0.5), transparent 55%)" }} />
                <span className="absolute left-4 top-4 rounded-full bg-slate-950/60 px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-white backdrop-blur">{p.category}</span>
              </div>
              <div className="p-6">
                <h2 className="font-display text-lg font-bold leading-snug text-slate-100 transition-colors group-hover:text-cyan-300">{p.title}</h2>
                <p className="mt-2.5 text-sm leading-relaxed text-slate-400">{p.excerpt}</p>
                <div className="mt-5 flex items-center justify-between text-xs text-slate-500">
                  <div className="flex items-center gap-4">
                    <span className="flex items-center gap-1.5"><CalendarDays className="h-3.5 w-3.5" />{p.date}</span>
                    <span className="flex items-center gap-1.5"><Clock className="h-3.5 w-3.5" />{p.read_time}</span>
                  </div>
                  <span className="flex items-center gap-1 font-semibold text-cyan-400">Czytaj <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" /></span>
                </div>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </main>
  );
}
